import { MuiMaterials } from "../@index";
import * as THREE from 'three';

const material = new THREE.MeshStandardMaterial({
    color: "rgb(235, 211, 124)",
    emissive: "rgb(0, 0, 0)",
    emissiveIntensity: 0.25,
    toneMapped: false,
    envMapIntensity: 1,
    transparent: true,
    opacity: 0.9,
    depthTest: true,
    depthWrite: true,
    side: THREE.DoubleSide,
    roughness: 0.4,
    metalness: 1,
    //fog: true,
    //wireframe: false,
    //normalMap: normalMapTexture,
});

const TestAsync = ({ item }) => {
    if (item && item.binRef) {
        let pointGeometry = new THREE.BoxGeometry(5, 5, 5);
        let mesh = new THREE.Mesh(pointGeometry, material);
        mesh.isGrainLight = true;
        //mesh.position.set(mesh.position.x, 50, mesh.position.z);
        item.binRef.add(mesh)
	}

  return (
      <MuiMaterials.Box
          sx={{
              color: "#f4cc8e61",
          }}
      >
        {item.id}
    </MuiMaterials.Box>
  );
};

export default TestAsync;